<script>

    import { createEventDispatcher } from 'svelte'

    import Button from '../$components/button.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import InputText from '../$components/input.text.svelte'
    import SelectUsers from '../$components/select.users.svelte'

    const dispatch = createEventDispatcher()

    export let zone
    export let canSave = false
    export let saving = false
    export let deleting = false

</script>

<style>
    .zone-form__title {
        margin: 0 0 12px;
        font-size: 15px;
        font-weight: 700;
        color: #1a1a1a;
    }

    .zone-form__color {
        display: block;
        width: 64px;
        height: 36px;
        padding: 2px;
        border: 1px solid #dbdbdb;
        border-radius: 8px;
        background: #fff;
        cursor: pointer;
    }

    .zone-form__help {
        margin: 0 0 12px;
        font-size: 12px;
        color: #6b6b6b;
    }

    .zone-form__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }
</style>

<form on:submit|preventDefault={() => dispatch('save')}>
    <h2 class="zone-form__title">{zone._id ? 'Editar zona' : 'Nueva zona'}</h2>

    <InputText label="Nombre" bind:value={zone.name} placeholder="Ej. Norte" />
    <InputText label="Código" bind:value={zone.code} placeholder="Ej. N-1" pattern={'[A-Za-z0-9\\-]{1,10}'} />
    <p class="zone-form__help">Hasta 10 letras, números o guiones. Se imprimirá en la guía de TIL.</p>

    <SelectUsers
        role="driver"
        label="Driver"
        bind:value={zone.driverEmail}
        bind:userId={zone.driverId}
    />

    <div class="field">
        <label class="label" for="zone-color">Color</label>
        <input id="zone-color" class="zone-form__color" type="color" bind:value={zone.color} />
    </div>

    {#if canSave}
        <p class="zone-form__help">
            En el mapa, arrastra la zona para moverla o un punto para ajustarla. Clic derecho en un punto lo quita.
        </p>
    {/if}

    <div class="zone-form__actions">
        {#if canSave}
            <ButtonSave loading={saving} />
        {/if}
        <Button text="Cancelar" on:click={() => dispatch('cancel')} />
        {#if zone._id}
            <ButtonDelete loading={deleting} on:confirm={() => dispatch('delete')} />
        {/if}
    </div>
</form>
